export const FileUploadErrorCodes = {
  FAILED: 'FAILED',
  FILE_READING_ERROR: 'FILE_READING_ERROR',
  SERVER_ERROR: 'SERVER_ERROR',
} as const;

export type FileUploadErrorCode = typeof FileUploadErrorCodes[keyof typeof FileUploadErrorCodes];

export const isFileUploadErrorCode = (code?: string): code is FileUploadErrorCode => {
  return Object.values(FileUploadErrorCodes).includes(code as FileUploadErrorCode);
};
